import React, {Component} from 'react';
import axios from 'axios';
import {Route, Switch, Redirect} from 'react-router-dom';
import './App.css';

import SblLanding from "./containers/sbl-landing/sbl-landing";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import history from './history';
import {Router} from 'react-router-dom';
import Home from "./containers/home/home";

class App extends Component {
    constructor(props) {
        super(props);

        // Add a response interceptor
        axios.interceptors.response.use((response) => {
            console.log("Axios Reponse: " + response);
            return response;
        }, (err) => {
            // Do something with response error
            console.log("Axios err: " + err);
            return Promise.reject(err);
        });
    }

    render() {
        return (
            <Router history={history}>
                <Switch>
                    {/*<Route path="/sbl-landing" component={SblLanding}/>*/}
                    <Route path="/" component={SblLanding}/>
                    <Redirect to="/"/>
                </Switch>
            </Router>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {

    };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/App.js